module.exports = __webpack_public_path__ + "images/gradient897838141f1926a249d20f36c29b2f69.png";